import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
// import List from "./List";
import Typography from "@material-ui/core/Typography";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Fade from "@material-ui/core/Fade";
import Collapse from "@material-ui/core/Collapse";
import { categoryImageFit } from "../Storefront/presentation/imageFit";
import { CircularProgress } from "@material-ui/core";
import { getCurrencyIcon } from "../../Helpers/currencyConverter";
import { isStorefrontFoundationEnabled } from "../Storefront/featureFlags";

const List = React.lazy(() => import("./List"));

export class Index extends Component {
  state = {
    SelectedCategory: null,
  };

  render() {
    const {
      language,
      settings,
      lastOpenedCategory,
      openedCategories,
      openedCategoriesInteracted,
      selectedCategory,
    } = this.props;
    const themeColor = this.props.themeColor
      ? this.props.themeColor
      : "#0099cc";
    const merchandisingEnabled = isStorefrontFoundationEnabled(settings);
    let categories = [];

    let border =
      language === "english"
        ? { borderLeft: `4px solid ${themeColor}` }
        : { borderRight: `4px solid ${themeColor}` };

    this.props.categories.forEach((category, index) => {
      // if (selectedCategory != "all") {
      //   index = this.props.categories.findIndex(
      //     (category) => category.id === selectedCategory.id
      //   );
      // }
      if (
        !merchandisingEnabled &&
        !settings.collapsed_by_default &&
        !openedCategoriesInteracted
      ) {
        this.props.updateCategoryState(true, index, true);
      }

      if (category.products.length) {
        const hasCoverPhoto =
          category?.cover_photo_large || category?.cover_photo ? true : false;
        const currencyIcon = getCurrencyIcon(settings)
        categories.push(
          <Accordion
            key={category.id}
            {...(merchandisingEnabled
              ? { expanded: openedCategories.includes(index) }
              : { defaultExpanded: openedCategories.includes(index) })}
            onChange={(e, expanded) => {
              this.props.saveLastOpenedCategory(expanded ? index : null);
              this.props.updateCategoryState(expanded, index, true);
            }}
            TransitionComponent={merchandisingEnabled ? Collapse : Fade}
            TransitionProps={{
              mountOnEnter: true,
              unmountOnExit: true,
              timeout: merchandisingEnabled && !window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ? 180 : 0,
            }}
          >
            <div id={"navigate" + category.id} aria-controls={merchandisingEnabled ? `category-${category.id}-content` : undefined}>
              {hasCoverPhoto && (
                <div style={{ padding: 15, paddingBottom: 0 }}>
                  <div
                    style={{
                      width: "100%",
                      height: "clamp(180px, 25vw, 270px)",
                    }}
                  >
                    <img
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: 5,
                      }}
                      src={category.cover_photo_large || category.cover_photo}
                    ></img>
                  </div>
                </div>
              )}
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={merchandisingEnabled ? `category-${category.id}-content` : "panel1a-content"}
                id={merchandisingEnabled ? `category-${category.id}-header` : "panel1a-header"}
                style={{
                  direction: language == "english" ? "ltr" : "rtl",
                  marginInline: hasCoverPhoto && 10,
                }}
              >
                {!hasCoverPhoto && category.photo ? (
                  <img
                    src={category.photo}
                    alt=""
                    style={{
                      width: merchandisingEnabled ? 48 : 40,
                      height: merchandisingEnabled ? 48 : 40,
                      objectFit: merchandisingEnabled ? categoryImageFit(settings) : undefined,
                      marginRight: language == "english" && 10,
                      marginLeft: language == "arabic" && 10,
                    }}
                  />
                ) : (
                  <></>
                )}
                <Typography
                  style={{
                    lineHeight: hasCoverPhoto ? 2 : 2.7,

                    fontWeight: "bold",
                  }}
                >
                  {language == "english"
                    ? category.name
                    : category.ar_name || category.name}{" "}
                  {category.minimum_order_value && (!merchandisingEnabled || (settings.show_prices !== false && !settings.is_menu)) ? (
                    language === "english" ? (
                      <span>
                        {"( Min Order "}
                        <span
                          className={
                            currencyIcon
                          }
                        >
                          {category.minimum_order_value}{" "}
                          {settings?.currency_english}
                        </span>
                        {" )"}
                      </span>
                    ) : (
                      <span>
                        {"( الحد الأدنى"}
                        <span
                          className={
                            currencyIcon
                          }
                        >
                          {category.minimum_order_value}{" "}
                          {settings?.currency_local}
                        </span>
                        {" )"}
                      </span>
                    )
                  ) : null}
                </Typography>
              </AccordionSummary>
            </div>
            <AccordionDetails style={{ padding: 0 }}>
              <Suspense
                fallback={
                  <div className="text-center">
                    <CircularProgress
                      color="primary"
                      style={{ marginTop: 20 }}
                    />
                  </div>
                }
              >
                <List
                  key={"List_Category " + category.name + category.id}
                  category={category}
                />
              </Suspense>
            </AccordionDetails>
          </Accordion>
        );
      }
    });

    return <div className={merchandisingEnabled ? "sf-collapse-categories" : "mb-5 w-100 h-100"}>{categories}</div>;
  }
}

const mapStateToProps = (state) => {
  return {
    categories: state.store.store.categories,
    language: state.store.language,
    themeColor: state.store.store.settings.dark,
    secondLoading: state.store.secondLoading,
    settings: state.store.store.settings,
    lastOpenedCategory: state.store.lastOpenedCategory,
    openedCategories: state.store.openedCategories,
    openedCategoriesInteracted: state.store.openedCategoriesInteracted,
    selectedCategory: state.selectedCategoryHeader.selectedCategory,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveLastOpenedCategory: (index) =>
      dispatch({ type: "SAVE_LAST_OPENED_CATEGORY", payload: index }),
    updateCategoryState: (expanded, index, interacted) =>
      dispatch({
        type: "UPDATE_CATEGORY_STATE",
        payload: { expanded, index, interacted },
      }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
